type TDateFilters = {
  minDate?: Date;
  maxDate?: Date;
};

/**
 *
 * @param yearFrom
 * Year array starting date.
 * @param options
 * Optional date array filters controlled with 'minDate' and 'maxDate' values.
 * @returns An array of years from the current year to the specifid dateFrom.
 *
 */

const getYears = (yearFrom: number, yearTo: number, options?: TDateFilters): number[] => {
  const containYearsBackward = yearTo - yearFrom;
  const years = Array.from(
    { length: containYearsBackward + 1 },
    (_, index) => yearTo - (containYearsBackward - index)
  ).reverse();

  const minDate = options?.minDate;
  const maxDate = options?.maxDate;
  if (!minDate && !maxDate) {
    return years;
  }

  const minYear = minDate?.getFullYear();
  const maxYear = maxDate?.getFullYear();
  const filteredYears = years.filter((year) => {
    if (minYear && year < minYear) {
      return false;
    }
    if (maxYear && year > maxYear) {
      return false;
    }

    return true;
  });

  return filteredYears;
};
export default getYears;
